(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3269],{

/***/ 82046:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals/search",
      function () {
        return __webpack_require__(5800);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transition: transform 0.1s linear;\n  transform: rotate(\n    ",
        "deg\n  );\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Chevron = function(param) {
    var _direction = param.direction, direction = _direction === void 0 ? _types_common__WEBPACK_IMPORTED_MODULE_2__/* .DIRECTION.BOTTOM */ .JR.BOTTOM : _direction, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 1.5 : _strokeWidth, _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 9 : _height, className = param.className, _color = param.color, color = _color === void 0 ? "black" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChevronSVG, {
        className: className,
        direction: direction,
        width: width,
        height: height,
        viewBox: "0 0 16 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            d: "M15 1L8 8L1 0.999999",
            stroke: color,
            strokeWidth: strokeWidth,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chevron);
var ChevronSVG = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-3e039213-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction === _types_common__WEBPACK_IMPORTED_MODULE_2__/* .DIRECTION.TOP */ .JR.TOP ? 180 : direction === _types_common__WEBPACK_IMPORTED_MODULE_2__/* .DIRECTION.RIGHT */ .JR.RIGHT ? -90 : direction === _types_common__WEBPACK_IMPORTED_MODULE_2__/* .DIRECTION.LEFT */ .JR.LEFT ? 90 : 0;
});


/***/ }),

/***/ 70253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var HeaderSearch = function(param) {
    var _size = param.size, size = _size === void 0 ? 20 : _size, _fill = param.fill, fill = _fill === void 0 ? "#A9AEB1" : _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_2367_13371)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.14439 0.00740448C6.96401 0.0621085 5.82582 0.358628 4.75176 0.89126C3.71218 1.40678 2.80897 2.1128 2.03838 3.0122C1.20773 3.98172 0.584464 5.18337 0.265416 6.43052C-0.088472 7.81385 -0.088472 9.30318 0.265416 10.6865C0.516512 11.668 0.962352 12.6367 1.54676 13.4705C1.95391 14.0514 2.45622 14.6026 3.01408 15.0805C3.9275 15.8631 5.04158 16.4594 6.21639 16.7946C7.37532 17.1252 8.62415 17.2049 9.83639 17.0255C11.0486 16.8462 12.2452 16.3869 13.2724 15.7065C13.367 15.6439 13.4775 15.5687 13.518 15.5396C13.5585 15.5104 13.5945 15.4865 13.598 15.4865C13.6015 15.4865 14.5458 16.4281 15.6964 17.5789C17.8031 19.686 17.8553 19.737 17.9884 19.8162C18.3586 20.0365 18.8396 20.0595 19.2351 19.8757C19.4965 19.7543 19.7562 19.4946 19.8776 19.2332C20.061 18.8385 20.0379 18.356 19.818 17.9865C19.7389 17.8535 19.6879 17.8013 17.5808 15.6945C16.43 14.5439 15.4884 13.5997 15.4884 13.5961C15.4884 13.5926 15.5123 13.5566 15.5414 13.5161C15.7821 13.1822 16.0292 12.7679 16.2319 12.3584C16.8245 11.1613 17.1203 9.89597 17.1203 8.55852C17.1203 7.21796 16.8232 5.95008 16.2279 4.75052C15.8091 3.90663 15.2849 3.17815 14.6128 2.50606C13.9404 1.8336 13.2115 1.30903 12.369 0.89126C11.2832 0.352788 10.1598 0.0622765 8.94839 0.00670048C8.74754 -0.00251552 8.35098 -0.00217152 8.14439 0.00740448ZM8.35239 2.67116C7.20874 2.70679 6.09237 3.08442 5.14757 3.75524C4.62973 4.12292 4.1248 4.62785 3.75712 5.14569C3.084 6.09372 2.70746 7.20968 2.67351 8.35725C2.64307 9.38588 2.84598 10.307 3.30485 11.2234C3.67525 11.9631 4.25066 12.6635 4.92324 13.1933C5.78954 13.8756 6.84643 14.3052 7.93639 14.418C8.32628 14.4584 8.79755 14.4583 9.18439 14.4179C10.2789 14.3035 11.3307 13.8761 12.1975 13.1933C12.5489 12.9166 12.9184 12.547 13.1952 12.1957C13.878 11.3288 14.3054 10.2771 14.4198 9.18252C14.4603 8.79528 14.4603 8.32176 14.4198 7.93452C14.3457 7.22517 14.1479 6.55594 13.8174 5.89668C13.3628 4.98968 12.6322 4.1777 11.7602 3.61041C10.8925 3.04588 9.81502 2.70236 8.82439 2.67441C8.74299 2.67212 8.64579 2.66913 8.60839 2.66777C8.57099 2.66642 8.45579 2.66795 8.35239 2.67116Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2367_13371",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderSearch);


/***/ }),

/***/ 18138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var BreadCrumbArrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.557 2.67311C5.43361 2.69613 5.32045 2.77137 5.25001 2.87723C5.20047 2.95168 5.17989 3.01695 5.17636 3.11082C5.17199 3.22681 5.19204 3.30295 5.25091 3.39399C5.26614 3.41752 5.75502 3.90878 7.5576 5.71185L9.84498 7.99985L7.5576 10.2879C5.75502 12.0909 5.26614 12.5822 5.25091 12.6057C5.19204 12.6968 5.17199 12.7729 5.17636 12.8889C5.17896 12.9579 5.18893 13.0034 5.21347 13.0579C5.26381 13.1698 5.37402 13.27 5.49032 13.3095C5.59721 13.3459 5.73841 13.3389 5.83633 13.2924C5.92155 13.2519 5.7554 13.4152 8.27956 10.891C9.62615 9.54438 10.6303 8.537 10.6468 8.51612C10.8436 8.26702 10.882 7.92846 10.7457 7.64359C10.7179 7.58549 10.6842 7.53099 10.6468 7.48359C10.6303 7.46271 9.62615 6.45533 8.27956 5.10871C6.23381 3.06291 5.93645 2.76711 5.90463 2.74629C5.82035 2.69112 5.75534 2.67081 5.65514 2.66833C5.61039 2.66722 5.58087 2.66866 5.557 2.67311Z",
            fill: "#A9AEB1"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbArrow);


/***/ }),

/***/ 31294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var CheckboxIcon = function(param) {
    var checked = param.checked;
    if (checked) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "24",
                    height: "24",
                    rx: "4",
                    fill: "#FD7E14"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17 9L10.125 16L7 12.8182",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "4",
                fill: "#EDEFF0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17 9L10.125 16L7 12.8182",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckboxIcon);


/***/ }),

/***/ 52443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ header_search_bar; }
});

// UNUSED EXPORTS: ArrowWrapper, SearchBarWrapper

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/icon/arrow/HeaderCaret.tsx
var HeaderCaret = __webpack_require__(68584);
// EXTERNAL MODULE: ./src/constants/zIndex.ts
var zIndex = __webpack_require__(31591);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/components/atom/icon/HeaderSearch.tsx
var HeaderSearch = __webpack_require__(70253);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/molecules/header-search-bar/SearchInput.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  margin-left: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  border: none;\n  height: 48px;\n  width: 100%;\n  padding: 0 48px 0 16px;\n  border-radius: 8px;\n\n  @media screen and (-webkit-min-device-pixel-ratio: 0) {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 12px;\n  border: none;\n  top: 50%;\n  transform: translate(0, -50%);\n  padding: 6px;\n  background: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var SearchInput = function(_param) {
    var onSubmit = _param.onSubmit, searchInputRef = _param.searchInputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onSubmit",
        "searchInputRef"
    ]);
    var handleSubmit = function(e) {
        var ref;
        e.preventDefault();
        searchInputRef === null || searchInputRef === void 0 ? void 0 : (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        onSubmit();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    tabIndex: 0
                }, props), {
                    ref: searchInputRef
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIconWrapper, {
                    type: "submit",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSearch/* default */.Z, {
                        size: 16,
                        fill: theme/* default.color.gray400 */.Z.color.gray400
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var header_search_bar_SearchInput = (SearchInput);
var SearchInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f29bfe2-0"
})(_templateObject());
var SearchInputStyled = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-7f29bfe2-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18M, ";\n    background: ").concat(theme.color.gray40, ";\n    color: ").concat(theme.color.gray700, ";\n    &::placeholder {\n      color: ").concat(theme.color.gray300, ";\n    }\n  ");
});
var SearchIconWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-7f29bfe2-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/components/molecules/header-search-bar/index.tsx



function header_search_bar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  position: sticky;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 6px 24px 6px 16px;\n  z-index: ",
        ";\n"
    ]);
    header_search_bar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_search_bar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px;\n  border: none;\n  border-radius: 4px;\n\n  &:active {\n    background-color: ",
        ";\n  }\n"
    ]);
    header_search_bar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var HeaderSearchBar = function(_param) {
    var isFixed = _param.isFixed, isMobileWeb = _param.isMobileWeb, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isFixed",
        "isMobileWeb"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarWrapper, {
        id: "appHeader",
        isFixed: isFixed,
        isMobileWeb: isMobileWeb,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowWrapper, {
                onClick: RNPlugins/* historyBack */.$i,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderCaret/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_search_bar_SearchInput, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
};
/* harmony default export */ var header_search_bar = (HeaderSearchBar);
var SearchBarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a8971807-0"
})(header_search_bar_templateObject(), function(param) {
    var theme = param.theme, isMobileWeb = param.isMobileWeb;
    return "\n    height: ".concat(theme.size.appHeader.height, ";\n    top: ").concat(isMobileWeb ? theme.size.mobileWebHeader.height : 0, "px;\n    background: ").concat(theme.color.white, ";\n    ");
}, zIndex/* zIndex.AppHeader */.W.AppHeader);
var ArrowWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a8971807-1"
})(header_search_bar_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});


/***/ }),

/***/ 99529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ DeeplinkLoggerEventName; }
/* harmony export */ });
var DeeplinkLoggerEventName;
(function(DeeplinkLoggerEventName) {
    DeeplinkLoggerEventName["ClickCtaButton"] = "click_cta_button";
    DeeplinkLoggerEventName["ImpressionQrFloating"] = "impression_qr_floating";
    DeeplinkLoggerEventName["ClickCtaText"] = "click_cta_text";
})(DeeplinkLoggerEventName || (DeeplinkLoggerEventName = {}));


/***/ }),

/***/ 77196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12436);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);






var useCustomRouter = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var moveToPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var webLink = param.webLink, mobileScreenName = param.mobileScreenName, params = param.params, as = param.as, _type = param.type, type = _type === void 0 ? _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE : _type;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .sendPostMessageToNative */ .T0)(type, {
                screenName: mobileScreenName,
                params: params ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params) : undefined
            });
        } else {
            if (!webLink) return;
            if (type === _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE) {
                router.replace(webLink, as);
                return;
            }
            router.push(webLink, as);
        }
    }, [
        router
    ]);
    var getCustomPageName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(defaultPageName) {
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? defaultPageName : (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getMobileWebPageName */ .b9)(router);
    }, [
        router
    ]);
    var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
    return {
        router: router,
        moveToPage: lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(moveToPage, 1500, {
            trailing: false
        }),
        getCustomPageName: getCustomPageName,
        pageName: pageName
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCustomRouter);


/***/ }),

/***/ 98266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var _recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11221);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74701);







var useModal = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilState)(_recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .modalState */ .e), 2), modals = ref[0], setModals = ref[1];
    var addModal = function(modal) {
        setModals(function(oldModals) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(oldModals).concat([
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, modal), {
                    index: oldModals.length + 1
                })
            ]);
        });
    };
    var showModal = function(param) {
        var type = param.type, props = param.props;
        switch(type){
            case _types_modal__WEBPACK_IMPORTED_MODULE_2__/* .MODAL_TYPE.BASIC */ .f.BASIC:
            default:
                addModal({
                    type: type,
                    props: props
                });
                break;
        }
    };
    var closeModal = function() {
        var tempModals = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(modals);
        tempModals.pop();
        setModals(tempModals);
    };
    return {
        isModalOpen: modals.length > 0,
        showModal: showModal,
        closeModal: closeModal
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useModal);


/***/ }),

/***/ 5800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/components/atom/icon/Chevron.tsx
var Chevron = __webpack_require__(44852);
// EXTERNAL MODULE: ./src/components/atom/icon/Phone.tsx
var Phone = __webpack_require__(75528);
// EXTERNAL MODULE: ./src/components/atom/icon/hospitals/NonF2fDiagnosisBannerIcon.tsx
var NonF2fDiagnosisBannerIcon = __webpack_require__(55394);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/header-search-bar/index.tsx + 1 modules
var header_search_bar = __webpack_require__(52443);
// EXTERNAL MODULE: ./src/components/templates/f2f/common/hospital-list/index.tsx
var hospital_list = __webpack_require__(77899);
// EXTERNAL MODULE: ./src/components/templates/f2f/common/hospital-region-filter-modal/index.tsx
var hospital_region_filter_modal = __webpack_require__(99332);
// EXTERNAL MODULE: ./src/components/atom/icon/search/HelpQuestion.tsx
var HelpQuestion = __webpack_require__(74976);
;// CONCATENATED MODULE: ./src/components/templates/f2f/common/search-hospital-result-empty/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  min-height: ",
        ";\n  text-align: center;\n  justify-content: center;\n  padding-top: 80px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin: 8px 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var SearchHospitalResultEmpty = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyResultWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpQuestion/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResultTitle, {
                    children: "찾으시는 병원이 없어요"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyResultOffer, {
                    children: [
                        "필터와 검색명을 확인하고",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "다시 검색해주세요."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyResultDescription, {
                    children: [
                        "TIP. 띄어쓰기를 주의하고",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        '주소를 "시 / 군 / 구 / 동"으로 검색해주세요!',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "예시)",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "관악구신림동(X), 금천구 시흥사거리(X)",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "관악구 신림동(O) 금천구 시흥동(O)"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var search_hospital_result_empty = (SearchHospitalResultEmpty);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f087134-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return "calc(100dvh - ".concat(theme.size.appHeader.height, ")");
});
var EmptyResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f087134-1"
})(_templateObject1());
var EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f087134-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f087134-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});
var EmptyResultDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f087134-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.typography.UI12R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray300;
});

// EXTERNAL MODULE: ./src/components/templates/mobile/f2f/hospital/hospitals-mobile-template/sticky-move-top-button/index.tsx + 1 modules
var sticky_move_top_button = __webpack_require__(39227);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/header.ts
var header = __webpack_require__(37072);
// EXTERNAL MODULE: ./src/types/hospital.ts
var types_hospital = __webpack_require__(24396);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
// EXTERNAL MODULE: ./src/components/common/ClickEventLogger.tsx
var ClickEventLogger = __webpack_require__(9558);
// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
// EXTERNAL MODULE: ./src/components/hospital/hospital-list-item/HospitalListItem.tsx
var HospitalListItem = __webpack_require__(76917);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-sub-category-template/hospital-search-event-item/index.tsx







var HospitalSearchEventItem = function(param) {
    var imageUrl = param.imageUrl, status = param.status, name = param.name, distance = param.distance, rating = param.rating, address = param.address, badges = param.badges, reviewTotalCount = param.reviewTotalCount, _isBookable = param.isBookable, isBookable = _isBookable === void 0 ? false : _isBookable, representativeDepartmentName = param.representativeDepartmentName, operationDisplay = param.operationDisplay, adBanners = param.adBanners, hospitalPid = param.hospitalPid, index = param.index, _doctorDetailPageHref = param.doctorDetailPageHref, doctorDetailPageHref = _doctorDetailPageHref === void 0 ? "" : _doctorDetailPageHref, onClickMoveToDoctorDetail = param.onClickMoveToDoctorDetail, onClickAdBanner = param.onClickAdBanner, hasNonF2fDoctors = param.hasNonF2fDoctors;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogger/* default */.Z, {
        pageName: (0,logger/* getPageName */.j0)(router),
        eventName: "click_hospital",
        payload: {
            section: isBookable ? "quick_search" : "nearby_search",
            position: index,
            hospital_id: hospitalPid,
            status: (0,format/* getDiagnosisStateText */.QN)(status)
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
            onClickNavigateToScreen: onClickMoveToDoctorDetail,
            href: doctorDetailPageHref,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalListItem/* default */.Z, {
                imageUrl: imageUrl,
                distance: distance,
                representativeDepartmentName: representativeDepartmentName,
                operationDisplay: operationDisplay,
                adBanners: adBanners,
                status: status,
                name: name,
                rating: rating,
                reviewTotalCount: reviewTotalCount,
                address: address,
                badges: badges,
                hospitalPid: hospitalPid,
                onClickMoveToDoctorDetail: onClickMoveToDoctorDetail,
                onClickAdBanner: onClickAdBanner,
                doctorDetailPageHref: doctorDetailPageHref,
                isBookable: isBookable,
                hasNonF2fDoctors: hasNonF2fDoctors
            })
        })
    });
};
/* harmony default export */ var hospital_search_event_item = (HospitalSearchEventItem);

;// CONCATENATED MODULE: ./src/components/atom/icon/Tune.tsx



var Tune = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _fill = param.fill, fill = _fill === void 0 ? theme/* default.color.primary600 */.Z.color.primary600 : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2 11.3333V12.6667H6V11.3333H2ZM2 3.33333V4.66667H8.66667V3.33333H2ZM8.66667 14V12.6667H14V11.3333H8.66667V10H7.33333V14H8.66667ZM4.66667 6V7.33333H2V8.66667H4.66667V10H6V6H4.66667ZM14 8.66667V7.33333H7.33333V8.66667H14ZM10 6H11.3333V4.66667H14V3.33333H11.3333V2H10V6Z",
            fill: fill
        })
    });
};
/* harmony default export */ var icon_Tune = (Tune);

;// CONCATENATED MODULE: ./src/components/templates/f2f/common/hospital-filter/index.tsx

function hospital_filter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        "\n          color: ",
        ";\n          background-color: ",
        ";\n          border: 1px solid ",
        ";\n        "
    ]);
    hospital_filter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function hospital_filter_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        "\n          color: ",
        ";\n          background-color: ",
        ";\n          border: 1px solid ",
        ";\n        "
    ]);
    hospital_filter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function hospital_filter_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 14px;\n  height: 36px;\n  border-radius: 40px;\n  & > * + * {\n    margin-left: 2px;\n  }\n  ",
        "\n"
    ]);
    hospital_filter_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var HospitalFilter = function(param) {
    var children = param.children, isSelected = param.isSelected, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_filter_Wrapper, {
        type: "button",
        isSelected: isSelected,
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ var hospital_filter = (HospitalFilter);
var hospital_filter_Wrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-d12d9f00-0"
})(hospital_filter_templateObject2(), function(param) {
    var theme = param.theme, isSelected = param.isSelected;
    return isSelected ? (0,styled_components_browser_esm/* css */.iv)(hospital_filter_templateObject(), theme.typography.UI14R, theme.color.primary700, theme.color.primary100, theme.color.primary600) : (0,styled_components_browser_esm/* css */.iv)(hospital_filter_templateObject1(), theme.typography.UI14R, theme.color.gray700, theme.color.gray30, theme.color.gray30);
});

;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-search-template/hospital-search-filters/index.tsx

function hospital_search_filters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  display: flex;\n  overflow: hidden;\n  padding: 12px 0 12px 24px;\n  z-index: 10;\n  background-color: ",
        ";\n  top: ",
        ";\n"
    ]);
    hospital_search_filters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function hospital_search_filters_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  white-space: nowrap;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  gap: 8px;\n  padding-left: 12px;\n  padding-right: 24px;\n"
    ]);
    hospital_search_filters_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function hospital_search_filters_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 12px;\n  border-right: 1px solid ",
        ";\n"
    ]);
    hospital_search_filters_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function hospital_search_filters_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid\n      ",
        ";\n    background-color: ",
        ";\n    border-radius: 50%;\n    &::after {\n      ",
        "\n      color: ",
        ";\n      display: ",
        ";\n      justify-content: center;\n      align-items: center;\n      position: absolute;\n      top: 0;\n      right: 0;\n      transform: translate(0, -3.5px);\n      content: '",
        "';\n      width: 14px;\n      height: 14px;\n      background-color: ",
        ";\n      border-radius: 50%;\n    }\n  "
    ]);
    hospital_search_filters_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function hospital_search_filters_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 36px;\n  height: 36px;\n  ",
        "\n"
    ]);
    hospital_search_filters_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var HospitalSearchFilters = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_search_filters_Wrapper, {
        children: children
    });
};
var EntireFilter = function(param) {
    var count = param.count, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EntireFilterWrapper, {
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntireFilterButton, {
            count: count,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_Tune, {
                fill: count > 0 ? theme/* default.color.primary600 */.Z.color.primary600 : theme/* default.color.black */.Z.color.black
            })
        })
    });
};
var ScrollFilters = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
        children: children
    });
};
/* harmony default export */ var hospital_search_filters = (HospitalSearchFilters);
HospitalSearchFilters.EntireFilter = EntireFilter;
HospitalSearchFilters.ScrollFilters = ScrollFilters;
HospitalSearchFilters.HospitalFilter = hospital_filter;
var hospital_search_filters_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-261e97e6-0"
})(hospital_search_filters_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var theme = param.theme;
    var client = theme.client;
    if (client.isWebView) {
        return "60px";
    }
    if (client.isMobile) {
        return "120px";
    }
    return "60px";
});
var ScrollWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-261e97e6-1"
})(hospital_search_filters_templateObject1());
var EntireFilterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-261e97e6-2"
})(hospital_search_filters_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.color.gray100;
});
var EntireFilterButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-261e97e6-3"
})(hospital_search_filters_templateObject4(), function(param) {
    var theme = param.theme, count = param.count;
    return (0,styled_components_browser_esm/* css */.iv)(hospital_search_filters_templateObject3(), count > 0 ? theme.color.primary600 : theme.color.gray100, count > 0 ? theme.color.primary100 : theme.color.white, theme.typography.UI10R, theme.color.white, count > 0 ? "flex" : "none", count, theme.color.red900);
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/components/atom/icon/search/CheckBoxIcon.tsx
var CheckBoxIcon = __webpack_require__(31294);
// EXTERNAL MODULE: ./src/components/templates/f2f/common/floating-bottom-sheet/index.tsx
var floating_bottom_sheet = __webpack_require__(3195);
// EXTERNAL MODULE: ./src/constants/zIndex.ts
var zIndex = __webpack_require__(31591);
// EXTERNAL MODULE: ./src/parsers/f2f/common/index.ts
var f2f_common = __webpack_require__(89325);
;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-search-template/search-entire-filter-bottom-sheet/index.tsx




function search_entire_filter_bottom_sheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  background-color: ",
        ";\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: ",
        ";\n  height: 100%;\n"
    ]);
    search_entire_filter_bottom_sheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_entire_filter_bottom_sheet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: scroll;\n  padding-bottom: 112px;\n"
    ]);
    search_entire_filter_bottom_sheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function search_entire_filter_bottom_sheet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n      color: ",
        ";\n    "
    ]);
    search_entire_filter_bottom_sheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function search_entire_filter_bottom_sheet_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  margin-bottom: 12px;\n  & > p {\n    ",
        "\n  }\n  & > div {\n    width: 24px;\n    height: 24px;\n  }\n"
    ]);
    search_entire_filter_bottom_sheet_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function search_entire_filter_bottom_sheet_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n"
    ]);
    search_entire_filter_bottom_sheet_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 5px;\n  margin-bottom: 20px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n      color: ",
        ";\n      padding: 0 12px;\n      margin-bottom: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 12px 12px;\n  & > p {\n    ",
        "\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    & > p {\n      ",
        "\n      color: ",
        ";\n      margin-right: auto;\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n  margin-right: auto;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 12px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 560px;\n  max-height: 85vh;\n  max-height: 85dvh;\n  padding-bottom: 24px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: scroll;\n  padding-bottom: 64px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n  padding: 0 24px 10px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    & > p {\n      ",
        "\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  height: 48px;\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 4px;\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    & > p {\n      ",
        "\n      color: ",
        ";\n    }\n    &:disabled {\n      background-color: ",
        ";\n      color: ",
        ";\n      & > p {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n  width: 110px;\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}











var SearchEntireFilterBottomSheet = function(props) {
    var isEntireFilterBottomSheet = props.isEntireFilterBottomSheet, client = props.client, toggleSearchEntireFilterBottomSheet = props.toggleSearchEntireFilterBottomSheet, isDefaultHospitalNearMode = props.isDefaultHospitalNearMode, isChangedHospitalFilters = props.isChangedHospitalFilters, hospitalCommonFilter = props.hospitalCommonFilter, locationName = props.locationName, switchRegionFilter = props.switchRegionFilter, sortFilterList = props.sortFilterList, selectedSortFilter = props.selectedSortFilter, updateEntireFilter = props.updateEntireFilter;
    var ref = (0,react.useState)(hospitalCommonFilter), innerHospitalCommonFilter = ref[0], setInnerHospitalCommonFilter = ref[1];
    var ref1 = (0,react.useState)(selectedSortFilter), innerHospitalSortFilter = ref1[0], setInnerHospitalSortFilter = ref1[1];
    var selectInnerHospitalSortFilter = function(sortFilter) {
        setInnerHospitalSortFilter(sortFilter);
    };
    var toggleInnerHospitalCommonFilter = function(type) {
        return function() {
            var updatedHospitalCommonFilter = new f2f_common/* HospitalSearchCommonFilter */.Q_((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, innerHospitalCommonFilter.values), (0,_define_property/* default */.Z)({}, type, !innerHospitalCommonFilter.values[type])));
            setInnerHospitalCommonFilter(updatedHospitalCommonFilter);
        };
    };
    var isSameHospitalCommonFilter = (0,react.useCallback)(function() {
        var sortedOuterCommonFilter = Object.keys(hospitalCommonFilter.values).sort().reduce(function(obj, key) {
            return obj[key] = hospitalCommonFilter.values[key], obj;
        }, {});
        var sortedInnerCommonFilter = Object.keys(innerHospitalCommonFilter.values).sort().reduce(function(obj, key) {
            return obj[key] = innerHospitalCommonFilter.values[key], obj;
        }, {});
        return JSON.stringify(sortedOuterCommonFilter) === JSON.stringify(sortedInnerCommonFilter);
    }, [
        innerHospitalCommonFilter,
        hospitalCommonFilter
    ]);
    var isEnableInitEntireFilter = function() {
        return isChangedHospitalFilters() || !selectedSortFilter.isSelected(innerHospitalSortFilter.type) || !isSameHospitalCommonFilter();
    };
    var initializeSortFilter = function() {
        return isDefaultHospitalNearMode() ? new f2f_common/* HospitalSortFilter */.vR(types_hospital/* HospitalSearchSortType.DISTANCE */.k_.DISTANCE) : new f2f_common/* HospitalSortFilter */.vR(types_hospital/* HospitalSearchSortType.ACCURACY */.k_.ACCURACY);
    };
    var initializeInnerFilters = function() {
        setInnerHospitalCommonFilter((0,f2f_common/* initializeHospitalSearchCommonFilter */.v1)());
        setInnerHospitalSortFilter(initializeSortFilter());
    };
    (0,react.useEffect)(function() {
        document.body.style.cssText = "\n      overflow: hidden;\n    ";
        return function() {
            document.body.style.cssText = "";
        };
    }, []);
    if (!isEntireFilterBottomSheet) return null;
    if (client.isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(search_entire_filter_bottom_sheet_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileModalHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton, {
                            onClick: toggleSearchEntireFilterBottomSheet,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "close",
                                size: 24,
                                color: theme/* default.color.gray900 */.Z.color.gray900
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "상세 필터"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(search_entire_filter_bottom_sheet_ScrollWrapper, {
                    children: [
                        isDefaultHospitalNearMode() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileFilterSection, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "위치"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterItem, {
                                            onClick: switchRegionFilter,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTitle, {
                                                    children: locationName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                    name: "arrow_forward_ios",
                                                    size: 20,
                                                    color: theme/* default.color.gray400 */.Z.color.gray400
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Division, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileFilterSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "정렬 필터"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList, {
                                    children: sortFilterList.map(function(sortFilter) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterItem, {
                                            onClick: function() {
                                                return selectInnerHospitalSortFilter(sortFilter);
                                            },
                                            children: [
                                                sortFilter.isSelected(innerHospitalSortFilter.type) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                    name: "radio_button_checked",
                                                    size: 24,
                                                    color: theme/* default.color.primary600 */.Z.color.primary600
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                    name: "radio_button_unchecked",
                                                    size: 24,
                                                    color: theme/* default.color.gray200 */.Z.color.gray200
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRightTitle, {
                                                    children: sortFilter.getTitle()
                                                })
                                            ]
                                        }, "entire-sortType-".concat(sortFilter.getTitle()));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Division, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileFilterSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "진료"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterList, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterItem, {
                                            onClick: toggleInnerHospitalCommonFilter(types_hospital/* HospitalCommonFilterType.Operating */.x6.Operating),
                                            children: [
                                                innerHospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.Operating */.x6.Operating) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                                    checked: true
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                                    checked: false
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRightTitle, {
                                                    children: "진료중"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterItem, {
                                            onClick: toggleInnerHospitalCommonFilter(types_hospital/* HospitalCommonFilterType.NightOperation */.x6.NightOperation),
                                            children: [
                                                innerHospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.NightOperation */.x6.NightOperation) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                                    checked: true
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                                    checked: false
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRightTitle, {
                                                    children: "야간진료"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Division, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterSection, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterItem, {
                                    onClick: toggleInnerHospitalCommonFilter(types_hospital/* HospitalCommonFilterType.Specialist */.x6.Specialist),
                                    children: [
                                        innerHospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.Specialist */.x6.Specialist) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                            checked: true
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                            checked: false
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRightTitle, {
                                            children: "전문의"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TransParentWrapper, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InitButton, {
                                    type: "button",
                                    disabled: !isEnableInitEntireFilter(),
                                    onClick: function() {
                                        return initializeInnerFilters();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                            name: "refresh",
                                            size: 20,
                                            color: isEnableInitEntireFilter() ? theme/* default.color.gray300 */.Z.color.gray300 : theme/* default.color.white */.Z.color.white
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "초기화"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                                    type: "button",
                                    onClick: function() {
                                        return updateEntireFilter({
                                            sortFilter: innerHospitalSortFilter,
                                            commonFilter: innerHospitalCommonFilter
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "적용"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(floating_bottom_sheet/* default */.Z, {
        isOpened: true,
        onClickOverlay: toggleSearchEntireFilterBottomSheet,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PcWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileModalHeader, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "상세 필터"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PcScrollWrapper, {
                    children: [
                        isDefaultHospitalNearMode() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileFilterSection, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "위치"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterItem, {
                                            onClick: switchRegionFilter,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTitle, {
                                                    children: locationName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                    name: "arrow_forward_ios",
                                                    size: 20,
                                                    color: theme/* default.color.gray400 */.Z.color.gray400
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Division, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileFilterSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "정렬 필터"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList, {
                                    children: sortFilterList.map(function(sortFilter) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterItem, {
                                            onClick: function() {
                                                return selectInnerHospitalSortFilter(sortFilter);
                                            },
                                            children: [
                                                sortFilter.isSelected(innerHospitalSortFilter.type) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                    name: "radio_button_checked",
                                                    size: 24,
                                                    color: theme/* default.color.primary600 */.Z.color.primary600
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                    name: "radio_button_unchecked",
                                                    size: 24,
                                                    color: theme/* default.color.gray200 */.Z.color.gray200
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRightTitle, {
                                                    children: sortFilter.getTitle()
                                                })
                                            ]
                                        }, "entire-sortType-".concat(sortFilter.getTitle()));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Division, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileFilterSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "진료"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterList, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterItem, {
                                            onClick: toggleInnerHospitalCommonFilter(types_hospital/* HospitalCommonFilterType.Operating */.x6.Operating),
                                            children: [
                                                innerHospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.Operating */.x6.Operating) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                                    checked: true
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                                    checked: false
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRightTitle, {
                                                    children: "진료중"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterItem, {
                                            onClick: toggleInnerHospitalCommonFilter(types_hospital/* HospitalCommonFilterType.NightOperation */.x6.NightOperation),
                                            children: [
                                                innerHospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.NightOperation */.x6.NightOperation) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                                    checked: true
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                                    checked: false
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRightTitle, {
                                                    children: "야간진료"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Division, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterSection, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterItem, {
                                    onClick: toggleInnerHospitalCommonFilter(types_hospital/* HospitalCommonFilterType.Specialist */.x6.Specialist),
                                    children: [
                                        innerHospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.Specialist */.x6.Specialist) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                            checked: true
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {
                                            checked: false
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRightTitle, {
                                            children: "전문의"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PcBottomSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TransParentWrapper, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InitButton, {
                                    type: "button",
                                    disabled: !isEnableInitEntireFilter(),
                                    onClick: function() {
                                        return initializeInnerFilters();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                            name: "refresh",
                                            size: 20,
                                            color: isEnableInitEntireFilter() ? theme/* default.color.gray300 */.Z.color.gray300 : theme/* default.color.white */.Z.color.white
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "초기화"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                                    type: "button",
                                    onClick: function() {
                                        return updateEntireFilter({
                                            sortFilter: innerHospitalSortFilter,
                                            commonFilter: innerHospitalCommonFilter
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "적용"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var search_entire_filter_bottom_sheet = (SearchEntireFilterBottomSheet);
var search_entire_filter_bottom_sheet_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-0"
})(search_entire_filter_bottom_sheet_templateObject(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
}, zIndex/* zIndex.MobileWebHeader */.W.MobileWebHeader);
var search_entire_filter_bottom_sheet_ScrollWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-1"
})(search_entire_filter_bottom_sheet_templateObject1());
var MobileModalHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-3bea6d85-2"
})(search_entire_filter_bottom_sheet_templateObject3(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(search_entire_filter_bottom_sheet_templateObject2(), _$theme.typography.UI20SB, _$theme.color.gray900);
});
var IconButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-3"
})(search_entire_filter_bottom_sheet_templateObject4());
var Division = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-4"
})(_templateObject5(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.gray30;
});
var MobileFilterSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3bea6d85-5"
})(_templateObject7(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), _$theme.typography.UI14M, _$theme.color.gray400);
});
var FilterList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-6"
})(_templateObject8());
var FilterItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-7"
})(_templateObject10(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), _$theme.typography.UI16R, _$theme.color.gray600);
});
var FilterTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-3bea6d85-8"
})(_templateObject11(), theme/* default.typography.UI16R */.Z.typography.UI16R, theme/* default.color.gray600 */.Z.color.gray600);
var FilterRightTitle = (0,styled_components_browser_esm/* default */.ZP)(FilterTitle).withConfig({
    componentId: "sc-3bea6d85-9"
})(_templateObject12());
var PcWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-10"
})(_templateObject13());
var PcScrollWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-11"
})(_templateObject14());
var ButtonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-12"
})(_templateObject15(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
});
var SubmitButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3bea6d85-13"
})(_templateObject17(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject16(), _$theme.color.primary500, _$theme.color.primary500, _$theme.typography.UI16SB, _$theme.color.white);
});
var InitButton = (0,styled_components_browser_esm/* default */.ZP)(SubmitButton).withConfig({
    componentId: "sc-3bea6d85-14"
})(_templateObject19(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject18(), _$theme.color.gray100, _$theme.color.white, _$theme.typography.UI14SB, _$theme.color.gray600, _$theme.color.gray100, _$theme.color.white, _$theme.color.white);
});
var TransParentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-15"
})(_templateObject20());
var BottomSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-16"
})(_templateObject21());
var PcBottomSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bea6d85-17"
})(_templateObject22());

;// CONCATENATED MODULE: ./src/components/atom/icon/Check.tsx


var Check = function(param) {
    var fill = param.fill, _size = param.size, size = _size === void 0 ? 32 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_5557_88846",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "32",
                height: "32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "32",
                    height: "32",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_5557_88846)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.7333 20.2L24.0333 8.9C24.2999 8.63333 24.6166 8.5 24.9833 8.5C25.35 8.5 25.6666 8.63333 25.9333 8.9C26.1999 9.16667 26.3333 9.48333 26.3333 9.85C26.3333 10.2167 26.1999 10.5333 25.9333 10.8L13.6666 23.0667C13.4 23.3333 13.0888 23.4667 12.7333 23.4667C12.3777 23.4667 12.0666 23.3333 11.8 23.0667L6.06662 17.3333C5.79995 17.0667 5.67217 16.75 5.68328 16.3833C5.69439 16.0167 5.83328 15.7 6.09995 15.4333C6.36662 15.1667 6.68328 15.0333 7.04995 15.0333C7.41662 15.0333 7.73328 15.1667 7.99995 15.4333L12.7333 20.2Z",
                    fill: fill
                })
            })
        ]
    });
};
/* harmony default export */ var icon_Check = (Check);

;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-search-template/search-sort-type-bottom-sheet/index.tsx

function search_sort_type_bottom_sheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px 12px;\n  ",
        "\n"
    ]);
    search_sort_type_bottom_sheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_sort_type_bottom_sheet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: ",
        "px;\n    display: flex;\n    flex-direction: column;\n    padding: 12px 0 24px;\n    & > h4 {\n      ",
        "\n      color: ",
        ";\n      padding: 0 24px;\n      margin-bottom: 8px;\n    }\n  "
    ]);
    search_sort_type_bottom_sheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function search_sort_type_bottom_sheet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    search_sort_type_bottom_sheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function search_sort_type_bottom_sheet_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    search_sort_type_bottom_sheet_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function search_sort_type_bottom_sheet_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n"
    ]);
    search_sort_type_bottom_sheet_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var SearchSortTypeBottomSheet = function(param) {
    var selectedSortFilter = param.selectedSortFilter, sortFilterList = param.sortFilterList, toggleModal = param.toggleModal, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(floating_bottom_sheet/* default */.Z, {
        index: 700,
        isOpened: true,
        onClickOverlay: toggleModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: "어떤 기준으로 정렬할까요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(search_sort_type_bottom_sheet_Wrapper, {
                    children: sortFilterList.map(function(sortFilter) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SortTypeItem, {
                            isSelected: sortFilter.isSelected(selectedSortFilter.type),
                            sortFilter: sortFilter,
                            onClick: onClick
                        }, "hospital-sortType-".concat(sortFilter.getTitle()));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var search_sort_type_bottom_sheet = (SearchSortTypeBottomSheet);
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-83f35a92-0"
})(search_sort_type_bottom_sheet_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, "\n    color: ").concat(theme.color.gray800, ";\n    ");
});
var SortTypeItem = function(param) {
    var sortFilter = param.sortFilter, isSelected = param.isSelected, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortTypeItemWrapper, {
        onClick: function() {
            return onClick(sortFilter);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: sortFilter.getTitle()
            }),
            isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_Check, {
                fill: theme/* default.color.primary500 */.Z.color.primary500
            })
        ]
    });
};
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-83f35a92-1"
})(search_sort_type_bottom_sheet_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(search_sort_type_bottom_sheet_templateObject1(), theme.client.isMobile ? 328 : 560, theme.typography.UI20SB, theme.color.gray800);
});
var search_sort_type_bottom_sheet_Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-83f35a92-2"
})(search_sort_type_bottom_sheet_templateObject3());
var SortTypeItemWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-83f35a92-3"
})(search_sort_type_bottom_sheet_templateObject4());

;// CONCATENATED MODULE: ./src/components/templates/f2f/hospital/hospitals-search-template/index.tsx



function hospitals_search_template_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n"
    ]);
    hospitals_search_template_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function hospitals_search_template_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: rotate(90deg);\n"
    ]);
    hospitals_search_template_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function hospitals_search_template_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n"
    ]);
    hospitals_search_template_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function hospitals_search_template_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  flex: 1 0 0;\n  border-radius: 8px;\n  background: ",
        ";\n"
    ]);
    hospitals_search_template_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function hospitals_search_template_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n"
    ]);
    hospitals_search_template_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function hospitals_search_template_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n"
    ]);
    hospitals_search_template_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function hospitals_search_template_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    hospitals_search_template_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function hospitals_search_template_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    hospitals_search_template_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



















// eslint-disable-next-line import/order

// eslint-disable-next-line import/order




var HospitalsSearchTemplate = function(param) {
    var client = param.client, viewModel = param.viewModel;
    var router = (0,next_router.useRouter)();
    var queries = router.query;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    visible: !client.isMobile,
                    type: "hospitals",
                    path: common/* ROUTES.HOSPITAL.SEARCH.path */.Z6.HOSPITAL.SEARCH.path + (0,url/* addQueryString */.sC)(queries)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                type: header/* HeaderType.WithMobileHeader */.n.WithMobileHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_search_bar/* default */.ZP, {
                    placeholder: "지역+과목명, 병원명을 입력해주세요",
                    onChange: function(e) {
                        return viewModel.handleInputChange(e.target.value);
                    },
                    value: viewModel.inputValue || "",
                    onSubmit: viewModel.handleChangeKeyword,
                    searchInputRef: viewModel.searchInputRef
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(hospital_search_filters, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_search_filters.EntireFilter, {
                                count: viewModel.filterCount,
                                onClick: viewModel.toggleSearchEntireFilterBottomSheet
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(hospital_search_filters.ScrollFilters, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(hospital_search_filters.HospitalFilter, {
                                        onClick: viewModel.toggleSortTypeBottomSheet,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: viewModel.selectedSortFilter.getTitle()
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RotationIcon, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                    name: "chevron_right",
                                                    size: 16,
                                                    color: theme/* default.color.gray700 */.Z.color.gray700
                                                })
                                            })
                                        ]
                                    }),
                                    viewModel.isDefaultHospitalNearMode() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(hospital_search_filters.HospitalFilter, {
                                        isSelected: viewModel.isLocationSelected() && viewModel.isDefaultHospitalNearMode(),
                                        onClick: viewModel.switchRegionFilter,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "my_location",
                                                size: 16,
                                                color: viewModel.isLocationSelected() && viewModel.isDefaultHospitalNearMode() ? theme/* default.color.primary600 */.Z.color.primary600 : theme/* default.color.gray700 */.Z.color.gray700,
                                                filled: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: viewModel.getHeaderAddress()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(hospital_search_filters.HospitalFilter, {
                                        isSelected: viewModel.hospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.NonF2f */.x6.NonF2f),
                                        onClick: viewModel.toggleHospitalFilter(types_hospital/* HospitalCommonFilterType.NonF2f */.x6.NonF2f),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, {
                                                size: 16,
                                                fill: viewModel.hospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.NonF2f */.x6.NonF2f) ? theme/* default.color.primary600 */.Z.color.primary600 : theme/* default.color.gray700 */.Z.color.gray700
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: viewModel.hospitalCommonFilter.getTitle(types_hospital/* HospitalCommonFilterType.NonF2f */.x6.NonF2f)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_search_filters.HospitalFilter, {
                                        isSelected: viewModel.hospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.Operating */.x6.Operating),
                                        onClick: viewModel.toggleHospitalFilter(types_hospital/* HospitalCommonFilterType.Operating */.x6.Operating),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: viewModel.hospitalCommonFilter.getTitle(types_hospital/* HospitalCommonFilterType.Operating */.x6.Operating)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_search_filters.HospitalFilter, {
                                        isSelected: viewModel.hospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.NightOperation */.x6.NightOperation),
                                        onClick: viewModel.toggleHospitalFilter(types_hospital/* HospitalCommonFilterType.NightOperation */.x6.NightOperation),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: viewModel.hospitalCommonFilter.getTitle(types_hospital/* HospitalCommonFilterType.NightOperation */.x6.NightOperation)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_search_filters.HospitalFilter, {
                                        isSelected: viewModel.hospitalCommonFilter.isSelected(types_hospital/* HospitalCommonFilterType.Specialist */.x6.Specialist),
                                        onClick: viewModel.toggleHospitalFilter(types_hospital/* HospitalCommonFilterType.Specialist */.x6.Specialist),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: viewModel.hospitalCommonFilter.getTitle(types_hospital/* HospitalCommonFilterType.Specialist */.x6.Specialist)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !!viewModel.keyword && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_list/* default */.Z, {
                                isLoading: viewModel.isLoadingHospitals,
                                fetchNextPage: viewModel.fetchNextPage,
                                hasNextPage: viewModel.hasNextPage,
                                hasHospitals: !!viewModel.hospitals.length,
                                children: viewModel.hospitals.map(function(hospital, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_search_event_item, {
                                                onClickAdBanner: viewModel.goToEventPage,
                                                onClickMoveToDoctorDetail: function() {
                                                    return viewModel.goToAppHospital(hospital.hospitalPublicId);
                                                },
                                                doctorDetailPageHref: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId),
                                                index: index,
                                                adBanners: hospital.hospitalAdBanners,
                                                hospitalPid: hospital.hospitalPublicId,
                                                status: hospital.hospitalOperationStatus,
                                                name: hospital.hospitalName,
                                                distance: hospital.hospitalDistance,
                                                rating: hospital.reviewScore,
                                                reviewTotalCount: hospital.reviewTotalCount,
                                                badges: hospital.hospitalBadges,
                                                imageUrl: hospital.hospitalRepresentativeImageUrl,
                                                address: hospital.hospitalAddress,
                                                isBookable: hospital.isBookable,
                                                representativeDepartmentName: hospital.hospitalRepresentativeDepartmentName,
                                                operationDisplay: hospital.operationDisplay,
                                                hasNonF2fDoctors: !!hospital.doctors.find(function(doctor) {
                                                    return doctor.contractType === types_hospital/* ContractType.All */.RJ.All;
                                                })
                                            }, "event-".concat(hospital.hospitalPublicId)),
                                            index === 1 && viewModel.matchedCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDoctorListBannerWrapper, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonF2fDoctorListBanner, {
                                                    onClick: viewModel.clickNonF2fDoctorListBanner,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonF2fDoctorListBannerContent, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDiagnosisBannerIcon/* default */.Z, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonF2fDcotorListBannerTextArea, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDoctorListBannerTitle, {
                                                                            children: "집에서 편하게 비대면 진료 받기"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDoctorListBannerDescription, {
                                                                            children: "병원 가지 않아도 진료를 볼 수 있어요"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                                            direction: common/* DIRECTION.RIGHT */.JR.RIGHT,
                                                            width: 12,
                                                            height: 12,
                                                            color: theme/* default.color.gray300 */.Z.color.gray300
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    });
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_move_top_button/* default */.Z, {})
                        ]
                    }),
                    viewModel.isVisibleDeleteIcon && !viewModel.isLoadingHospitals && viewModel.hasNoData && /*#__PURE__*/ (0,jsx_runtime.jsx)(search_hospital_result_empty, {})
                ]
            }),
            viewModel.isSortTypeBottomSheetOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(search_sort_type_bottom_sheet, {
                sortFilterList: viewModel.sortFilterList,
                selectedSortFilter: viewModel.selectedSortFilter,
                toggleModal: viewModel.toggleSortTypeBottomSheet,
                onClick: viewModel.selectHospitalSortFilter
            }),
            viewModel.isRegionFilterOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_region_filter_modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, viewModel.getRegionFilterProps()), {
                isOpened: viewModel.isRegionFilterOpened,
                client: client
            })),
            viewModel.isSearchEntireFilterBottomSheet && /*#__PURE__*/ (0,jsx_runtime.jsx)(search_entire_filter_bottom_sheet, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, viewModel.getSearchEntireFilterBottomSheetProps()), {
                client: client
            }))
        ]
    });
};
/* harmony default export */ var hospitals_search_template = (HospitalsSearchTemplate);
var BreadCrumbsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74254f74-0"
})(hospitals_search_template_templateObject(), function(param) {
    var theme = param.theme;
    return theme.client.isMobile ? "0" : "24px 24px 16px";
});
var RotationIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74254f74-1"
})(hospitals_search_template_templateObject1());
var NonF2fDoctorListBannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74254f74-2"
})(hospitals_search_template_templateObject2());
var NonF2fDoctorListBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74254f74-3"
})(hospitals_search_template_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});
var NonF2fDoctorListBannerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74254f74-4"
})(hospitals_search_template_templateObject4());
var NonF2fDcotorListBannerTextArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74254f74-5"
})(hospitals_search_template_templateObject5());
var NonF2fDoctorListBannerTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74254f74-6"
})(hospitals_search_template_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI14M, ";\n      color: ").concat(theme.color.gray800, ";\n    ");
});
var NonF2fDoctorListBannerDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74254f74-7"
})(hospitals_search_template_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI12R, ";\n      color: ").concat(theme.color.gray500, "\n    ");
});

// EXTERNAL MODULE: ./src/hooks/cuj/useAppDownloadCujModal.tsx + 1 modules
var useAppDownloadCujModal = __webpack_require__(11989);
// EXTERNAL MODULE: ./src/hooks/hospital/list/useSearchHospitalsGenerally.ts + 2 modules
var useSearchHospitalsGenerally = __webpack_require__(92312);
// EXTERNAL MODULE: ./src/hooks/search/useInfiniteSearchNonF2fDoctors.ts
var useInfiniteSearchNonF2fDoctors = __webpack_require__(48115);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/components/templates/f2f/hospital/hospital-bottom-sheet/non-f2f-diagnosis-app-install-bottom-sheet/NonF2fDiagnosisAppInstallBottomSheet.tsx + 1 modules
var NonF2fDiagnosisAppInstallBottomSheet = __webpack_require__(34701);
// EXTERNAL MODULE: ./src/components/templates/f2f/hospital/hospital-bottom-sheet/non-f2f-diagnosis-app-install-qr-code-bottom-sheet/NonF2fDiagnosisAppInstallQrCodeBottomSheet.tsx
var NonF2fDiagnosisAppInstallQrCodeBottomSheet = __webpack_require__(38494);
// EXTERNAL MODULE: ./src/constants/logs/deeplink/index.ts
var deeplink = __webpack_require__(99529);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(95613);
// EXTERNAL MODULE: ./src/constants/f2f/index.ts
var f2f = __webpack_require__(93247);
;// CONCATENATED MODULE: ./src/hooks/hospital/search/useHospitalSearchFilters.ts











var _obj;
var hospitalCommonFilterTypeLogNameMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types_hospital/* HospitalCommonFilterType.Bookable */.x6.Bookable, f2f/* FaceToFaceLog.click_filter_easy_booking */.Gg.click_filter_easy_booking), (0,_define_property/* default */.Z)(_obj, types_hospital/* HospitalCommonFilterType.NightOperation */.x6.NightOperation, f2f/* FaceToFaceLog.click_filter_night_operation */.Gg.click_filter_night_operation), (0,_define_property/* default */.Z)(_obj, types_hospital/* HospitalCommonFilterType.Operating */.x6.Operating, f2f/* FaceToFaceLog.click_filter_operating */.Gg.click_filter_operating), (0,_define_property/* default */.Z)(_obj, types_hospital/* HospitalCommonFilterType.Specialist */.x6.Specialist, f2f/* FaceToFaceLog.click_filter_professional */.Gg.click_filter_professional), (0,_define_property/* default */.Z)(_obj, types_hospital/* HospitalCommonFilterType.NonF2f */.x6.NonF2f, f2f/* FaceToFaceLog.click_filter_nonF2f */.Gg.click_filter_nonF2f), (0,_define_property/* default */.Z)(_obj, types_hospital/* HospitalCommonFilterType.SundayOperation */.x6.SundayOperation, f2f/* FaceToFaceLog.click_filter_sunday_operation */.Gg.click_filter_sunday_operation), _obj);
var useHospitalSearchFilters = function() {
    var router = (0,next_router.useRouter)();
    var _query = router.query, sortType = _query.sortType, mode = _query.mode, commonFilter = _query.commonFilter;
    var selectedSortFilter = (0,f2f_common/* getHospitalSearchSortFilter */.G$)(sortType);
    var ref = (0,react.useState)(false), isSortTypeBottomSheetOpen = ref[0], setIsSortTypeBottomSheetOpen = ref[1];
    var ref1 = (0,react.useState)(false), isSearchEntireFilterBottomSheet = ref1[0], setIsSearchEntireFilterBottomSheet = ref1[1];
    var hospitalCommonFilter = (0,f2f_common/* getHospitalCommonFilter */.Mc)(commonFilter);
    var commonFilterCount = Object.values(hospitalCommonFilter.values).filter(function(value) {
        return Boolean(value);
    }).length;
    var sortFilterList = Object.values(types_hospital/* HospitalSearchSortType */.k_).map(function(sortType) {
        return new f2f_common/* HospitalSortFilter */.vR(sortType);
    });
    var toggleSortTypeBottomSheet = function() {
        setIsSortTypeBottomSheetOpen(function(prev) {
            return !prev;
        });
    };
    var toggleSearchEntireFilterBottomSheet = function() {
        if (!isSearchEntireFilterBottomSheet) {
            (0,logger/* faceTofaceLogger */.vS)({
                eventName: f2f/* FaceToFaceLog.click_filter_detail */.Gg.click_filter_detail,
                pageName: (0,logger/* getPageName */.j0)(router)
            });
        }
        setIsSearchEntireFilterBottomSheet(function(prev) {
            return !prev;
        });
    };
    var selectHospitalSortFilter = function(sortFilter) {
        (0,logger/* faceTofaceLogger */.vS)({
            eventName: f2f/* FaceToFaceLog.click_filter_sorting */.Gg.click_filter_sorting,
            pageName: (0,logger/* getPageName */.j0)(router),
            payload: {
                sortType: sortFilter.getTitle()
            }
        });
        (0,url/* updateSearchParams */.aM)([
            {
                key: types_hospital/* HospitalSearchParamsQueries.SortType */.UG.SortType,
                value: sortFilter.type
            }
        ]);
        setIsSortTypeBottomSheetOpen(false);
    };
    var toggleHospitalFilter = function(type) {
        return function() {
            (0,logger/* faceTofaceLogger */.vS)({
                eventName: hospitalCommonFilterTypeLogNameMap[type],
                pageName: (0,logger/* getPageName */.j0)(router),
                payload: {
                    status: hospitalCommonFilter.values[type] ? "ON" : "OFF"
                }
            });
            var currentCommonFilter = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hospitalCommonFilter.values), (0,_define_property/* default */.Z)({}, type, !hospitalCommonFilter.values[type]));
            (0,url/* updateSearchParams */.aM)([
                {
                    key: types_hospital/* HospitalSearchParamsQueries.CommonFilter */.UG.CommonFilter,
                    value: (0,format/* getCommonFilterQueryString */.hq)(currentCommonFilter)
                }, 
            ]);
        };
    };
    var isDefaultHospitalNearMode = function() {
        return (0,f2f_common/* getHospitalSearchMode */.Ko)(mode) === types_hospital/* HospitalSearchMode.NEAR */.LC.NEAR;
    };
    var updateEntireFilter = function(param) {
        var commonFilter = param.commonFilter, sortFilter = param.sortFilter;
        (0,logger/* faceTofaceLogger */.vS)({
            eventName: f2f/* FaceToFaceLog.click_filter_detail_apply */.Gg.click_filter_detail_apply,
            pageName: (0,logger/* getPageName */.j0)(router),
            payload: {
                sortType: sortFilter.getTitle(),
                easy_booking: commonFilter.isSelected(types_hospital/* HospitalCommonFilterType.Bookable */.x6.Bookable) ? "ON" : "OFF",
                professional: commonFilter.isSelected(types_hospital/* HospitalCommonFilterType.Specialist */.x6.Specialist) ? "ON" : "OFF",
                night_operation: commonFilter.isSelected(types_hospital/* HospitalCommonFilterType.NightOperation */.x6.NightOperation) ? "ON" : "OFF",
                operating: commonFilter.isSelected(types_hospital/* HospitalCommonFilterType.Operating */.x6.Operating) ? "ON" : "OFF"
            }
        });
        (0,url/* updateSearchParams */.aM)([
            {
                key: types_hospital/* HospitalSearchParamsQueries.CommonFilter */.UG.CommonFilter,
                value: (0,format/* getCommonFilterQueryString */.hq)(commonFilter.values)
            },
            {
                key: types_hospital/* HospitalSearchParamsQueries.SortType */.UG.SortType,
                value: sortFilter.type
            }, 
        ]);
        toggleSearchEntireFilterBottomSheet();
    };
    var isChangedHospitalFilters = function() {
        if (commonFilterCount > 0) {
            return true;
        }
        return isDefaultHospitalNearMode() ? selectedSortFilter.type !== types_hospital/* HospitalSearchSortType.DISTANCE */.k_.DISTANCE : selectedSortFilter.type !== types_hospital/* HospitalSearchSortType.ACCURACY */.k_.ACCURACY;
    };
    return {
        hospitalCommonFilter: hospitalCommonFilter,
        selectedSortFilter: selectedSortFilter,
        sortFilterList: sortFilterList,
        commonFilterCount: commonFilterCount,
        isSortTypeBottomSheetOpen: isSortTypeBottomSheetOpen,
        isDefaultHospitalNearMode: isDefaultHospitalNearMode,
        toggleHospitalFilter: toggleHospitalFilter,
        selectHospitalSortFilter: selectHospitalSortFilter,
        toggleSortTypeBottomSheet: toggleSortTypeBottomSheet,
        isSearchEntireFilterBottomSheet: isSearchEntireFilterBottomSheet,
        toggleSearchEntireFilterBottomSheet: toggleSearchEntireFilterBottomSheet,
        updateEntireFilter: updateEntireFilter,
        isChangedHospitalFilters: isChangedHospitalFilters
    };
};
/* harmony default export */ var search_useHospitalSearchFilters = (useHospitalSearchFilters);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/utils/validate.ts
var validate = __webpack_require__(64002);
;// CONCATENATED MODULE: ./src/hooks/hospital/search/useSearchHospitalsByKeyword.ts











var useSearchHospitalsByKeyword = function() {
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref = (0,useCustomRouter/* default */.Z)(), router = ref.router, pageName = ref.pageName;
    var ref1 = (0,useModal/* default */.Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var _query = router.query, tmp = _query.keyword, queryKeyword = tmp === void 0 ? "" : tmp;
    var searchInputRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(queryKeyword), inputValue = ref2[0], setInputValue = ref2[1];
    var ref3 = (0,react.useState)(queryKeyword), keyword = ref3[0], setKeyword = ref3[1];
    var handleInputChange = function(value) {
        setInputValue(value);
    };
    var handleResetInput = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setInputValue("");
                        setKeyword("");
                        (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
                        (0,url/* deleteQueryString */.OB)(types_hospital/* HospitalSearchParamsQueries.Keyword */.UG.Keyword);
                        return [
                            4,
                            queryClient.invalidateQueries([
                                "SearchHospitalGenerally"
                            ])
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleResetInput(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeKeyword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var inputKeyword;
            return (0,tslib_es6.__generator)(this, function(_state) {
                inputKeyword = inputValue.trim();
                if (!inputKeyword) {
                    showModal({
                        type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                        props: {
                            title: "검색어를 입력해주세요.",
                            buttons: [
                                {
                                    type: modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                                    label: "확인",
                                    onClick: function() {
                                        return closeModal();
                                    }
                                }
                            ]
                        }
                    });
                    return [
                        2
                    ];
                }
                if (inputKeyword.length < 2) {
                    showModal({
                        type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                        props: {
                            title: "2글자 이상 입력해 주세요.",
                            message: "더 정확도 높은 결과를 볼 수 있어요.",
                            buttons: [
                                {
                                    type: modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                                    label: "확인",
                                    onClick: function() {
                                        return closeModal();
                                    }
                                }
                            ]
                        }
                    });
                    return [
                        2
                    ];
                }
                if (!(0,validate/* validateNonSpecialPattern */.G5)(inputKeyword)) {
                    showModal({
                        type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                        props: {
                            title: "특수문자를 지원하지 않아요.",
                            message: "다른 검색어를 입력해주세요.",
                            buttons: [
                                {
                                    type: modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                                    label: "확인",
                                    onClick: function() {
                                        return closeModal();
                                    }
                                }
                            ]
                        }
                    });
                    return [
                        2
                    ];
                }
                (0,logger/* faceTofaceLogger */.vS)({
                    eventName: "click_search",
                    pageName: pageName,
                    payload: {
                        section: "search_bar",
                        keyword: inputKeyword
                    }
                });
                (0,url/* updateSearchParams */.aM)([
                    {
                        key: types_hospital/* HospitalSearchParamsQueries.Keyword */.UG.Keyword,
                        value: inputKeyword
                    },
                    {
                        key: types_hospital/* HospitalSearchParamsQueries.Mode */.UG.Mode,
                        value: types_hospital/* HospitalSearchMode.SEARCH */.LC.SEARCH
                    },
                    {
                        key: types_hospital/* HospitalSearchParamsQueries.SortType */.UG.SortType,
                        value: types_hospital/* HospitalSearchSortType.ACCURACY */.k_.ACCURACY
                    }
                ]);
                setSearchKeyword(inputKeyword);
                return [
                    2
                ];
            });
        });
        return function handleChangeKeyword() {
            return _ref.apply(this, arguments);
        };
    }();
    var setSearchKeyword = function(keyword) {
        var ref;
        setKeyword(keyword);
        (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
    };
    return {
        inputValue: inputValue,
        searchInputRef: searchInputRef,
        isVisibleDeleteIcon: !!keyword,
        handleChangeKeyword: handleChangeKeyword,
        handleInputChange: handleInputChange,
        handleResetInput: handleResetInput,
        keyword: keyword
    };
};
/* harmony default export */ var search_useSearchHospitalsByKeyword = (useSearchHospitalsByKeyword);

// EXTERNAL MODULE: ../../node_modules/lodash/find.js
var find = __webpack_require__(55281);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
// EXTERNAL MODULE: ../../node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(45455);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ../../node_modules/lodash/toNumber.js
var toNumber = __webpack_require__(7642);
var toNumber_default = /*#__PURE__*/__webpack_require__.n(toNumber);
// EXTERNAL MODULE: ./src/hooks/useScreenFocus.tsx
var useScreenFocus = __webpack_require__(50341);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/services/hospital/SearchHospitalService.ts
var SearchHospitalService = __webpack_require__(23144);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useGetAddressToCoordinateByIp.ts
var useGetAddressToCoordinateByIp = __webpack_require__(49626);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useGetUserAddressByLocation.ts
var useGetUserAddressByLocation = __webpack_require__(77688);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useGetUserAddresses.ts
var useGetUserAddresses = __webpack_require__(63983);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useSearchKoreaAddressV2.ts
var useSearchKoreaAddressV2 = __webpack_require__(75527);
;// CONCATENATED MODULE: ./src/hooks/hospital/search/useUserLocation.ts



















var initSidoSeoul = {
    centroidLatitude: 37.55191888765841,
    centroidLongitude: 126.99182510819786,
    displayName: "서울",
    regionCode: "11",
    regionName: "서울특별시"
};
var useUserLocation = function() {
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var pageName = (0,logger/* getPageName */.j0)(router);
    var isFocused = (0,useScreenFocus/* default */.Z)();
    var isLoggedIn = !!(0,auth/* getAuthToken */.bW)();
    var showToast = (0,useToast/* default */.Z)().showToast;
    var _query = router.query, queryLatitude = _query.latitude, queryLongitude = _query.longitude;
    var queryCoord = (0,react.useMemo)(function() {
        if (!queryLatitude || !queryLongitude) {
            return SearchHospitalService/* SearchHospitalService.initializeUserCoordinate */.h.initializeUserCoordinate();
        }
        var latitude = toNumber_default()(queryLatitude);
        var longitude = toNumber_default()(queryLongitude);
        if (isNaN(latitude) || isNaN(longitude)) {
            return SearchHospitalService/* SearchHospitalService.initializeUserCoordinate */.h.initializeUserCoordinate();
        }
        return {
            latitude: latitude,
            longitude: longitude
        };
    }, [
        queryLatitude,
        queryLongitude
    ]);
    var ref4 = (0,react.useState)(false), isRegionFilterOpened = ref4[0], setIsRegionFilterOpened = ref4[1];
    var ref5 = (0,react.useState)(), regionByDepth = ref5[0], setRegionByDepth = ref5[1];
    var ref6 = (0,react.useState)({
        siDo: initSidoSeoul,
        siGunGu: null,
        dong: null
    }), selectedRegion = ref6[0], setSelectedRegion = ref6[1];
    var isSejong = ((ref = selectedRegion.siDo) === null || ref === void 0 ? void 0 : ref.regionCode) === "36";
    var isLocationSelected = function() {
        return !!regionByDepth || !!queryLatitude && !!queryLongitude;
    };
    var ref7 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: null,
        siGunGuCode: null
    }), tmp = ref7.data, siDoList = tmp === void 0 ? [] : tmp;
    var ref8 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: isSejong ? "" : ((ref1 = selectedRegion.siDo) === null || ref1 === void 0 ? void 0 : ref1.regionCode) || "",
        siGunGuCode: null
    }), tmp1 = ref8.data, siGunGuList = tmp1 === void 0 ? [] : tmp1;
    var ref9 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: ((ref2 = selectedRegion.siDo) === null || ref2 === void 0 ? void 0 : ref2.regionCode) || "",
        siGunGuCode: isSejong ? null : ((ref3 = selectedRegion.siGunGu) === null || ref3 === void 0 ? void 0 : ref3.regionCode) || ""
    }), tmp2 = ref9.data, dongList = tmp2 === void 0 ? [] : tmp2;
    var ref10 = (0,useGetAddressToCoordinateByIp/* default */.Z)(), userCoordinateByIp = ref10.data;
    var ref11 = (0,useGetUserAddressByLocation/* default */.Z)(queryCoord.latitude, queryCoord.longitude), tmp3 = ref11.data, sigunguDongli = tmp3 === void 0 ? SearchHospitalService/* SearchHospitalService.initializeUserSigunguDongli */.h.initializeUserSigunguDongli() : tmp3, addressFetch = ref11.refetch;
    var ref12 = (0,useGetUserAddresses/* default */.Z)(), addresses = ref12.data, refetchAddresses = ref12.refetch;
    var getHeaderAddress = function() {
        var address = "".concat(sigunguDongli.dongLi);
        if (regionByDepth === null || regionByDepth === void 0 ? void 0 : regionByDepth.siDoName) {
            if (!regionByDepth.siGunGuName && !regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName);
            } else if (regionByDepth.siGunGuName && !regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siGunGuName);
            } else if (regionByDepth.siGunGuName && regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.legalEupMyeonDongName);
            } else if (!regionByDepth.siGunGuName && regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.legalEupMyeonDongName);
            }
        }
        return address;
    };
    var getHeaderFullAddress = function() {
        var address = "".concat(sigunguDongli.sigungu, " ").concat(sigunguDongli.dongLi);
        if (regionByDepth === null || regionByDepth === void 0 ? void 0 : regionByDepth.siDoName) {
            if (!regionByDepth.siGunGuName && !regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName);
            } else if (regionByDepth.siGunGuName && !regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName, " ").concat(regionByDepth.siGunGuName);
            } else if (regionByDepth.siGunGuName && regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siGunGuName, " ").concat(regionByDepth.legalEupMyeonDongName);
            } else if (!regionByDepth.siGunGuName && regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName, " ").concat(regionByDepth.legalEupMyeonDongName);
            }
        }
        return address;
    };
    var switchRegionFilter = function() {
        // 지역필터 모달 오픈시
        if (!isRegionFilterOpened) {
            (0,logger/* faceTofaceLogger */.vS)({
                pageName: pageName,
                eventName: "click_region_filter"
            });
        }
        setIsRegionFilterOpened(!isRegionFilterOpened);
    };
    var selectRegion = function(region) {
        setRegionByDepth({
            siDoName: region.siDoName,
            siGunGuName: region === null || region === void 0 ? void 0 : region.siGunGuName,
            legalEupMyeonDongName: region === null || region === void 0 ? void 0 : region.dongName
        });
        setIsRegionFilterOpened(false);
    };
    var changeSiDo = (0,react.useCallback)(function(siDo, isAll) {
        setSelectedRegion({
            siDo: siDo,
            siGunGu: null,
            dong: null
        });
        if (isAll) {
            selectRegion({
                siDoName: siDo.regionName,
                siGunGuName: undefined,
                dongName: undefined
            });
        }
    }, []);
    var clickSiDo = function(item, isAll) {
        return function(event) {
            (0,logger/* faceTofaceLogger */.vS)({
                pageName: pageName,
                eventName: "click_region_filter_find",
                payload: {
                    sector_1: item.regionName
                }
            });
            event.stopPropagation();
            changeSiDo(item, isAll);
        };
    };
    var changeSiGunGu = function(siGunGu, isAll) {
        var ref;
        if (!(selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.siDo)) return;
        if (!isAll && siGunGu.regionCode === ((ref = selectedRegion.siGunGu) === null || ref === void 0 ? void 0 : ref.regionCode)) {
            setSelectedRegion((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedRegion), {
                siGunGu: null,
                dong: null
            }));
            return;
        }
        setSelectedRegion((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedRegion), {
            siGunGu: siGunGu,
            dong: null
        }));
        if (isAll) {
            selectRegion({
                siDoName: selectedRegion.siDo.regionName,
                siGunGuName: siGunGu.regionName
            });
        }
    };
    var clickSiGunGu = function(item, isAll) {
        return function(event) {
            var ref;
            var ref1;
            (0,logger/* faceTofaceLogger */.vS)({
                pageName: pageName,
                eventName: "click_region_filter_find",
                payload: {
                    sector_1: (ref1 = (ref = selectedRegion.siDo) === null || ref === void 0 ? void 0 : ref.regionName) !== null && ref1 !== void 0 ? ref1 : "",
                    sector_2: item.regionName
                }
            });
            event.stopPropagation();
            changeSiGunGu(item, isAll);
        };
    };
    var changeDong = function(dong) {
        var ref;
        if (!dong.regionCode || !selectedRegion.siDo) return;
        setSelectedRegion((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedRegion), {
            dong: dong
        }));
        selectRegion({
            siDoName: selectedRegion.siDo.regionName,
            siGunGuName: (ref = selectedRegion.siGunGu) === null || ref === void 0 ? void 0 : ref.regionName,
            dongName: dong === null || dong === void 0 ? void 0 : dong.regionName
        });
    };
    var clickDong = function(item) {
        return function(event) {
            var ref, ref1;
            var ref2, ref3;
            (0,logger/* faceTofaceLogger */.vS)({
                pageName: pageName,
                eventName: "click_region_filter_find",
                payload: {
                    sector_1: (ref2 = (ref = selectedRegion.siDo) === null || ref === void 0 ? void 0 : ref.regionName) !== null && ref2 !== void 0 ? ref2 : "",
                    sector_2: (ref3 = (ref1 = selectedRegion.siGunGu) === null || ref1 === void 0 ? void 0 : ref1.regionName) !== null && ref3 !== void 0 ? ref3 : "",
                    sector_3: item.regionName
                }
            });
            event.stopPropagation();
            changeDong(item);
        };
    };
    var initRegionFilter = function() {
        setSelectedRegion({
            siDo: null,
            siGunGu: null,
            dong: null
        });
        setRegionByDepth(undefined);
    };
    var updatePureCoordinate = function(coord) {
        (0,url/* updateSearchParams */.aM)([
            {
                key: "latitude",
                value: coord.latitude
            },
            {
                key: "longitude",
                value: coord.longitude
            }, 
        ]);
    };
    var updateCoordinate = (0,react.useCallback)(function(coord) {
        initRegionFilter();
        updatePureCoordinate(coord);
    }, []);
    var getCurrentLocation = function(nonLog) {
        if (!nonLog) {
            (0,logger/* faceTofaceLogger */.vS)({
                pageName: pageName,
                eventName: "click_region_filter_my_location"
            });
        }
        requestGeolocationPermission();
        setIsRegionFilterOpened(false);
    };
    var requestPureGeolocationPermission = (0,react.useCallback)(function() {
        if (!navigator.geolocation) {
            return;
        }
        navigator.geolocation.getCurrentPosition(function(param) {
            var coords = param.coords;
            updatePureCoordinate({
                latitude: coords.latitude,
                longitude: coords.longitude
            });
        }, function() {
            return;
        }, {
            enableHighAccuracy: true
        });
    }, []);
    var requestGeolocationPermission = function() {
        initRegionFilter();
        if (!navigator.geolocation) {
            showToast({
                message: "다른 브라우저로 해당 기능을 이용해주세요"
            });
            return;
        }
        navigator.geolocation.getCurrentPosition(function(param) {
            var coords = param.coords;
            updatePureCoordinate({
                latitude: coords.latitude,
                longitude: coords.longitude
            });
        }, function() {
            showToast({
                message: "위치 사용을 허용을 해야 내 위치 설정이 가능해요"
            });
        }, {
            enableHighAccuracy: true
        });
    };
    var selectSavedAddress = function(coordiname) {
        return function() {
            updateCoordinate(coordiname);
            switchRegionFilter();
        };
    };
    var goToAppMyPageAddressScreen = function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
                screenName: "AddressStack",
                params: {
                    screen: common/* ROUTES.ADDRESS.HOME.appScreenName */.Z6.ADDRESS.HOME.appScreenName
                }
            });
        }
    };
    var getRegionFilterProps = function() {
        return {
            isRegionFilterOpened: isRegionFilterOpened,
            siDoList: siDoList,
            siGunGuList: siGunGuList,
            sigunguDongli: sigunguDongli,
            dongList: dongList,
            selectedRegion: selectedRegion,
            isSejong: isSejong,
            addresses: addresses,
            coordinate: queryCoord,
            getCurrentLocation: getCurrentLocation,
            switchRegionFilter: switchRegionFilter,
            selectSavedAddress: selectSavedAddress,
            goToAppMyPageAddressScreen: goToAppMyPageAddressScreen,
            clickSiDo: clickSiDo,
            clickSiGunGu: clickSiGunGu,
            clickDong: clickDong
        };
    };
    var getCoordinateToString = function() {
        return {
            latitude: String(queryCoord.latitude),
            longitude: String(queryCoord.longitude)
        };
    };
    (0,react.useEffect)(function() {
        if (!isEmpty_default()(siDoList) && !selectedRegion.siDo) {
            var seoul = find_default()(siDoList, {
                regionCode: "11"
            });
            if (seoul) {
                setSelectedRegion({
                    siDo: seoul,
                    dong: null,
                    siGunGu: null
                });
            }
        }
    }, [
        siDoList,
        selectedRegion.siDo,
        changeSiDo
    ]);
    (0,react.useEffect)(function() {
        addressFetch();
    }, [
        queryCoord,
        addressFetch
    ]);
    (0,react.useEffect)(function() {
        if (queryLatitude && queryLongitude) return;
        if (!userCoordinateByIp) return requestPureGeolocationPermission();
        updateCoordinate(userCoordinateByIp);
    }, [
        queryLatitude,
        queryLongitude,
        requestPureGeolocationPermission,
        updateCoordinate,
        userCoordinateByIp
    ]);
    (0,react.useEffect)(function() {
        if (isFocused && isLoggedIn) {
            refetchAddresses();
        }
    }, [
        isFocused,
        isLoggedIn
    ]);
    return {
        coordinate: queryCoord,
        isLocationSelected: isLocationSelected,
        isRegionFilterOpened: isRegionFilterOpened,
        regionByDepth: regionByDepth,
        switchRegionFilter: switchRegionFilter,
        getHeaderAddress: getHeaderAddress,
        getCoordinateToString: getCoordinateToString,
        getRegionFilterProps: getRegionFilterProps,
        getHeaderFullAddress: getHeaderFullAddress
    };
};
/* harmony default export */ var search_useUserLocation = (useUserLocation);

;// CONCATENATED MODULE: ./src/hooks/hospital/search/useHospitalsSearchViewModel.tsx





















var useHospitalsSearchViewModel = function(client) {
    var router = (0,next_router.useRouter)();
    var queries = router.query;
    var setIsCujModalTrackingInfo = (0,useAppDownloadCujModal/* default */.Z)().setIsCujModalTrackingInfo;
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)();
    var locationHook = search_useUserLocation();
    var hospitalFiltersHook = search_useHospitalSearchFilters();
    var keywordHook = search_useSearchHospitalsByKeyword();
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var ref1 = (0,useInfiniteSearchNonF2fDoctors/* default */.Z)({
        request: {
            keyword: keywordHook.keyword,
            sortType: gql_schema/* DoctorSortType.Random */.tt_.Random,
            page: 1,
            limit: 1,
            doctorType: gql_schema/* DoctorType.Doctor */.J42.Doctor,
            telemedicineEligibleTargetType: gql_schema/* TelemedicineEligibleTargetType.NightAndHolidayOnly */.H7r.NightAndHolidayOnly
        }
    }, {
        enabled: !!keywordHook.keyword
    }), matchedCategory = ref1.category;
    var getCoordinateToString = locationHook.getCoordinateToString, regionByDepth = locationHook.regionByDepth, switchRegionFilter = locationHook.switchRegionFilter, getHeaderFullAddress = locationHook.getHeaderFullAddress, isLocationSelected = locationHook.isLocationSelected;
    var isDefaultHospitalNearMode = hospitalFiltersHook.isDefaultHospitalNearMode, isSearchEntireFilterBottomSheet = hospitalFiltersHook.isSearchEntireFilterBottomSheet, toggleSearchEntireFilterBottomSheet = hospitalFiltersHook.toggleSearchEntireFilterBottomSheet, updateEntireFilter = hospitalFiltersHook.updateEntireFilter, hospitalCommonFilter = hospitalFiltersHook.hospitalCommonFilter, sortFilterList = hospitalFiltersHook.sortFilterList, selectedSortFilter = hospitalFiltersHook.selectedSortFilter, commonFilterCount = hospitalFiltersHook.commonFilterCount, isChangedHospitalFilters = hospitalFiltersHook.isChangedHospitalFilters;
    var searchHospitalHook = (0,useSearchHospitalsGenerally/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getCoordinateToString()), {
        keyword: queries.keyword,
        sortType: queries.sortType,
        regionByDepth: isDefaultHospitalNearMode() && !!regionByDepth ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, regionByDepth), {
            siDoName: (regionByDepth === null || regionByDepth === void 0 ? void 0 : regionByDepth.siDoName) || ""
        }) : undefined,
        commonFilter: queries.commonFilter
    }));
    var filterCount = commonFilterCount + (isLocationSelected() && isDefaultHospitalNearMode() ? 1 : 0);
    var goToEventPage = function(eventUrl, hospitalPid) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
                screenName: common/* ROUTES.HOSPITAL.EVENT.appScreenName */.Z6.HOSPITAL.EVENT.appScreenName,
                params: {
                    hospitalPid: hospitalPid,
                    eventUrl: eventUrl
                }
            });
            return;
        }
        router.push("".concat(common/* ROUTES.HOSPITAL.EVENT.path */.Z6.HOSPITAL.EVENT.path).concat((0,url/* addQueryString */.sC)({
            eventUrl: eventUrl,
            hospitalPid: hospitalPid
        })));
    };
    var clickNonF2fDoctorListBanner = function() {
        if ((0,RNPlugins/* isWebView */.vp)() && matchedCategory) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_DOCTOR_LIST_WITH_TARGET_CHECK */.nn.MOVE_TO_DOCTOR_LIST_WITH_TARGET_CHECK, {
                type: matchedCategory.category,
                id: matchedCategory.id
            });
            return;
        }
        var options = {
            campaign: "web_hospitals_search",
            content: "web_content_flt_details",
            term: "비대면 진료 배너 클릭"
        };
        if (client.isMobile) {
            return showModal({
                type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
                props: {
                    body: /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDiagnosisAppInstallBottomSheet/* default */.Z, {
                        onClickAppInstall: function() {
                            return airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, options);
                        },
                        onClickOverlay: closeModal
                    })
                }
            });
        }
        return showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDiagnosisAppInstallQrCodeBottomSheet/* default */.Z, {
                    appInstallLink: airbridgeDynamicLink.getDynamicLink(options),
                    onClickOverlay: closeModal
                })
            }
        });
    };
    var getSearchEntireFilterBottomSheetProps = function() {
        return {
            isEntireFilterBottomSheet: isSearchEntireFilterBottomSheet,
            toggleSearchEntireFilterBottomSheet: toggleSearchEntireFilterBottomSheet,
            isDefaultHospitalNearMode: isDefaultHospitalNearMode,
            locationName: getHeaderFullAddress(),
            switchRegionFilter: switchRegionFilter,
            hospitalCommonFilter: hospitalCommonFilter,
            sortFilterList: sortFilterList,
            selectedSortFilter: selectedSortFilter,
            isChangedHospitalFilters: isChangedHospitalFilters,
            updateEntireFilter: updateEntireFilter
        };
    };
    (0,react.useEffect)(function() {
        setIsCujModalTrackingInfo({
            campaignName: "web_hospitals",
            trackContent: "web_mdl_list",
            contentId: keywordHook.keyword
        });
    }, []);
    (0,react.useEffect)(function() {
        window.scrollTo({
            top: 0
        });
    }, [
        router.query
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, keywordHook, searchHospitalHook, hospitalFiltersHook, locationHook), {
        getSearchEntireFilterBottomSheetProps: getSearchEntireFilterBottomSheetProps,
        filterCount: filterCount,
        goToEventPage: goToEventPage,
        clickNonF2fDoctorListBanner: clickNonF2fDoctorListBanner,
        matchedCategory: matchedCategory
    });
};
/* harmony default export */ var search_useHospitalsSearchViewModel = (useHospitalsSearchViewModel);

;// CONCATENATED MODULE: ./src/pages/hospitals/search/index.tsx
// PageDescription: 대면진료 병원 검색 페이지









var SearchHospitalSeo = function(param) {
    var queries = param.queries, hospitals = param.hospitals;
    var ref;
    var hospitalsJson = (0,format/* createSearchHospitalLdJson */.M)(hospitals, queries.keyword);
    var ref1;
    var totalCount = (ref1 = (ref = hospitals[0]) === null || ref === void 0 ? void 0 : ref.hospitalTotalCount) !== null && ref1 !== void 0 ? ref1 : 0;
    var title = queries.keyword ? "".concat(queries.keyword, " 인기 병원 TOP10 - 닥터나우") : "인기 병원 TOP10 - 닥터나우";
    var description = queries.keyword ? "인기 병원을 바로 예약할 수 있어요. TOP10을 포함한 ".concat(queries.keyword, " ").concat(totalCount, "개 중 나에게 꼭 맞는 병원을 선택해 보세요!") : "인기 병원을 바로 예약할 수 있어요. TOP10을 포함한 76,614개 중 나에게 꼭 맞는 병원을 선택해 보세요!";
    var canonical = queries.keyword ? "".concat("https://doctornow.co.kr").concat(common/* ROUTES.HOSPITAL.SEARCH.path */.Z6.HOSPITAL.SEARCH.path, "?keyword=").concat(queries.keyword) : "".concat("https://doctornow.co.kr").concat(common/* ROUTES.HOSPITAL.SEARCH.path */.Z6.HOSPITAL.SEARCH.path);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: description,
                canonical: canonical,
                openGraph: {
                    title: title,
                    description: "병원 위치부터 후기까지 확인 후, 예약해 보세요!",
                    url: canonical,
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/hospital_logo.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(hospitalsJson)
                    }
                })
            })
        ]
    });
};
var SearchHospitalsPage = function(param) {
    var client = param.client, queries = param.queries;
    var viewModel = search_useHospitalsSearchViewModel(client);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchHospitalSeo, {
                queries: queries,
                hospitals: viewModel.hospitals
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hospitals_search_template, {
                client: client,
                viewModel: viewModel
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var search = (SearchHospitalsPage);
SearchHospitalsPage.Layout = DefaultLayout/* default */.Z;


/***/ }),

/***/ 95613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ hooks_useAirbridgeDynamicLink; }
});

// UNUSED EXPORTS: useDebounceWithLoading

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/constants/env.ts
var env = __webpack_require__(5322);
// EXTERNAL MODULE: ./src/shared/types/index.ts + 1 modules
var types = __webpack_require__(9628);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/firebase.ts + 10 modules
var firebase = __webpack_require__(59334);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/shared/hooks/useAirbridgeDynamicLink.ts










var AIRBRIDGE_PARAM_PREFIX = "ab_";
var sanitizeEventName = function(eventName) {
    return eventName.replace(/[^\w]/g, "_");
};
var formatOptionsForLogging = function(options) {
    return Object.fromEntries(Object.entries(options).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return [
            "".concat(AIRBRIDGE_PARAM_PREFIX).concat(key),
            typeof value === "number" ? value.toString() : value, 
        ];
    }));
};
var useAirbridgeDynamicLink = function() {
    var channel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "web_organic", initOptions = arguments.length > 1 ? arguments[1] : void 0;
    var router = (0,next_router.useRouter)();
    var getDynamicLink = function(options) {
        var linkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridge/* default.getDynamicLink */.Z.getDynamicLink((0,_object_spread/* default */.Z)({
            channel: channel
        }, initOptions, options), linkType);
    };
    var getTrackingParams = function() {
        var linkType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridge/* default.getTrackingParams */.Z.getTrackingParams(linkType);
    };
    var createTrackingLinkAsync = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(channel, options) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    airbridge/* default.createTrackingLinkAsync */.Z.createTrackingLinkAsync(channel, options)
                ];
            });
        });
        return function createTrackingLinkAsync(channel, options) {
            return _ref.apply(this, arguments);
        };
    }();
    var logToFirebase = function(eventName, options) {
        var pageName = (0,logger/* getPageName */.j0)(router);
        var sanitizedEventName = sanitizeEventName(eventName);
        var formattedOptions = formatOptionsForLogging((0,_object_spread/* default */.Z)({}, initOptions, options));
        var payload = (0,_object_spread/* default */.Z)({
            page_name: pageName
        }, formattedOptions);
        if (env/* IS_LOCAL */.Kc) {
            console.log("logger >>", (0,_object_spread/* default */.Z)({
                eventName: sanitizedEventName
            }, payload));
            return;
        }
        firebase/* default.logEventOnlyFirebase */.Z.logEventOnlyFirebase(sanitizedEventName, payload);
    };
    var navigateWithTracking = function(eventName, options) {
        var linkType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        var customOptions = (0,_object_spread/* default */.Z)({}, initOptions, options);
        logToFirebase(eventName, customOptions);
        airbridge/* default.setDynamicLink */.Z.setDynamicLink((0,_object_spread/* default */.Z)({
            channel: channel
        }, customOptions), linkType);
    };
    return {
        navigateWithTracking: navigateWithTracking,
        getDynamicLink: getDynamicLink,
        getTrackingParams: getTrackingParams,
        logToFirebase: logToFirebase,
        createTrackingLinkAsync: createTrackingLinkAsync
    };
};
/* harmony default export */ var hooks_useAirbridgeDynamicLink = (useAirbridgeDynamicLink);

// EXTERNAL MODULE: ./src/shared/hooks/useDebounceWithLoading.ts
var useDebounceWithLoading = __webpack_require__(78974);
;// CONCATENATED MODULE: ./src/shared/hooks/index.ts





/***/ }),

/***/ 78974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54073);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18149);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var useDebounceWithLoading = function(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, options = arguments.length > 2 ? arguments[2] : void 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(value), debounced = ref[0], setDebounced = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var previousValue = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // 객체의 실제 내용이 이전과 다르면 로딩 상태 시작
        if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(previousValue.current, value)) {
            setIsLoading(true);
            previousValue.current = value;
        }
        var handler = lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()(function() {
            setDebounced(value);
            setIsLoading(false);
        }, delay, options);
        handler();
        return function() {
            handler.cancel();
        };
    }, [
        value,
        delay,
        options
    ]);
    return {
        debouncedValue: debounced,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDebounceWithLoading);


/***/ }),

/***/ 45162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tq": function() { return /* binding */ AuthorType; },
/* harmony export */   "Zg": function() { return /* binding */ MagazineTagType; },
/* harmony export */   "pO": function() { return /* binding */ EDoctorCareer; },
/* harmony export */   "rL": function() { return /* binding */ MagazineType; },
/* harmony export */   "wK": function() { return /* binding */ MagazineBottomButtonType; }
/* harmony export */ });
/* unused harmony export CoreCategoryType */
var MagazineType = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    ARTICLE: "ARTICLE",
    FAQ: "FAQ"
};
var MagazineTagType;
(function(MagazineTagType) {
    MagazineTagType["DEPARTMENT"] = "DEPARTMENT";
    MagazineTagType["SYMPTOM"] = "SYMPTOM";
    MagazineTagType["DISEASE"] = "DISEASE";
    MagazineTagType["FREE"] = "FREE";
})(MagazineTagType || (MagazineTagType = {}));
var CoreCategoryType;
(function(CoreCategoryType) {
    CoreCategoryType["Department"] = "DEPARTMENT";
    CoreCategoryType["Disease"] = "DISEASE";
    CoreCategoryType["Symptom"] = "SYMPTOM";
})(CoreCategoryType || (CoreCategoryType = {}));
var AuthorType;
(function(AuthorType) {
    AuthorType["DOCTOR"] = "DOCTOR";
    AuthorType["AI"] = "AI";
    AuthorType["NURSE"] = "NURSE";
    AuthorType["MEDICAL_PROFESSIONAL_EDITOR"] = "MEDICAL_PROFESSIONAL_EDITOR";
    AuthorType["GENERAL_EDITOR"] = "GENERAL_EDITOR";
})(AuthorType || (AuthorType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["DEPARTMENT"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var MagazineBottomButtonType;
(function(MagazineBottomButtonType) {
    MagazineBottomButtonType["QUESTION"] = "QUESTION";
    MagazineBottomButtonType["DIAGNOSIS"] = "DIAGNOSIS";
})(MagazineBottomButtonType || (MagazineBottomButtonType = {}));
var EDoctorCareer;
(function(EDoctorCareer) {
    EDoctorCareer["CURRENT"] = "CURRENT";
    EDoctorCareer["PAST"] = "PAST";
    EDoctorCareer["GRADUATION"] = "GRADUATION";
    EDoctorCareer["COMPLETION"] = "COMPLETION";
})(EDoctorCareer || (EDoctorCareer = {}));


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,6492,9097,10,4059,8330,3679,8391,9653,5180,8185,7808,5964,3775,194,9332,9774,2888,179], function() { return __webpack_exec__(82046); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);